import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import { FaLinkedin, FaInstagramSquare, FaTwitterSquare } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import  footerLogo  from "../Assets/Images/FooterLogo.png";

const Footer = () => {
  const navigate = useNavigate();

  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNavigation = (path) => {
    navigate(path);
    scrollToTop();
  };

  return (
    <div className="footerContianer">
      <div className="logo-section_f">
        <img
          src={footerLogo}
          alt="Company Logo"
          className="logoimage_f"
        />
        <p className="logo_text_f">Accelerate with Accuracy</p>
        <p className="logotextone_f_1">
          The era of pen and paper is far behind you, the era of automation -
          just in front of you.
        </p>
        <p className="logo_text_f_2">
          Do you want to move your business from analog to digital, swiftly and
          securely? Send us a message today.
        </p>
        <div className="social_links">
          <a
            href="https://www.linkedin.com/company/68694837/admin/dashboard/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>

          <a
            href="https://www.instagram.com/arshilllc_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagramSquare />
          </a>

          <a
            href="https://x.com/arshil_llc"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitterSquare />
          </a>

          <a
            href="https://www.youtube.com/@arshilllc"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoYoutube />
          </a>
        </div>
      </div>

      <div className="QuickLinks">
        <h5>Quick Links</h5>
        <p onClick={() => handleNavigation("/")}>Home</p>
        <p onClick={() => handleNavigation("/services/ApplicationDevelopment")}>
          Services
        </p>
        <p onClick={() => handleNavigation("/industries/Healthcare")}>
          Industries
        </p>
        <p onClick={() => handleNavigation("/products")}>Akscel</p>
        <p onClick={() => handleNavigation("/blogs")}>Blogs</p>
      </div>

      <div className="CompanyDetails">
        <h5>Company</h5>
        <p onClick={() => handleNavigation("/contact")}>Contact Us</p>
        <p onClick={() => handleNavigation("/about")}>About Us</p>
        <p onClick={() => handleNavigation("/PrivacyPolicy")}>
          Privacy Policies
        </p>
      </div>

      <div className="officeDetails">
        <h5>Office</h5>
        <p>Ashburn, Virginia, US</p>
        <p>Hyderabad, India</p>
        <p>Ontario, Canada</p>
      </div>
    </div>
  );
};

export default Footer;
